class NewsListController {
  constructor() {
  }
}

export default NewsListController;



// WEBPACK FOOTER //
// ./client/app/components/apps/newsList/newsList.controller.js